import ReactDOM from 'react-dom';
import styled, { useTheme } from 'styled-components';
import cn from 'classnames';
import DeviceManager from '@/components/util/deviceManager';
import { useBasicStore, useUIStore } from '../../../../store';
import { TourType } from '@/_models/Tour';
import { TTheme } from '@/_models/Common';

const SubtitleWrap = styled.div`
  pointer-events: none;
  position: fixed;
  width: 100%;
  text-align: center;
  display: flex;
  z-index: 1;
  align-items: center;
  justify-content: center;

  .subtitles-text {
    color: white;
    position: relative;
    z-index: 1;
    padding: 10px;
  }
  .subtitles-bg {
    width: 100%;
    height: 100%;
    display: inline-block;
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    //background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(15px);
    border-radius: 4px;
  }
  @media screen and (orientation: landscape) {
    width: 100%;
  }
  @media screen and (min-width: 760px) {
    &:not(.mobile) {
      .subtitles-text {
        max-width: 70vw;
      }
    }
  }
  @media screen and (max-width: 480px) {
    .subtitles-text {
      max-width: initial;
    }
  }
`;

const AudioSubtitleBlock = (props: {
  currentSubText: string;
  group: any;
  isRtl: boolean;
  hideSubtitlesGroupId: number;
  flowIsActive: boolean;
}) => {
  const { currentSubText, group = {}, hideSubtitlesGroupId, isRtl, flowIsActive } = props;
  const isBbOpen = useUIStore((state) => state.bottomBarOpen);
  const isMobile = DeviceManager.isMobile();
  const { tourType } = useBasicStore((state) => state.tourConfigs);
  const { device }: TTheme = useTheme();
  const audioConfigs = useBasicStore((state) => state.audioConfigs);
  const { mobile, landscape } = device || {};
  if (group?.hideSubsOnMobile && mobile) return null; // hide subs on mobile crm toggle
  if (!audioConfigs.captionsEnabled || hideSubtitlesGroupId === group?.id) return null;
  const hideConfigsBlock = document.querySelector('.ec-bb-main .hideConfigs');
  let bbOpenBottom = '262px';
  let bbClosedBottom = '75px';
  if (tourType === TourType.ECommerce) {
    if (mobile && landscape) {
      bbOpenBottom = '187px';
    } else {
      bbOpenBottom = '262px';
      bbClosedBottom = hideConfigsBlock ? '75px' : '50px';
    }
  }
  if (tourType === TourType.Game || flowIsActive) {
    bbOpenBottom = '155px';
  }

  const blockToInsert = (
    <SubtitleWrap
      className={cn('bt-audio-subs', isMobile && 'mobile')}
      style={{ bottom: isBbOpen || flowIsActive ? bbOpenBottom : bbClosedBottom }}
    >
      {currentSubText && (
        <div
          className="subtitles-text"
          style={{
            fontFamily: group?.fontFamily !== 'null' ? group?.fontFamily : 'Heebo, sans-serif',
            color: group?.musicSubFontColor,
            fontSize: group?.musicSubFontSize,
            direction: isRtl || group?.subtitlesRTL ? 'rtl' : 'initial',
            textShadow: group?.subBgShadow
              ? '0 1px 0 rgb(0 0 0 / 30%), 0 -1px 0 rgb(0 0 0 / 30%), -1px 0 0 rgb(0 0 0 / 30%), 1px 0 0 rgb(0 0 0 / 30%), 0 5px 24px rgb(0 0 0 / 35%), 0 6px 31px rgb(0 0 0 / 90%)'
              : '',
          }}
        >
          {currentSubText}
          {!group?.subBgShadow && (
            <div
              className="subtitles-bg"
              style={{
                opacity: group?.musicSubBgOpacity / 100,
                backgroundColor: group?.musicSubBgColor,
              }}
            />
          )}
        </div>
      )}
    </SubtitleWrap>
  );
  const pathExisting = document.querySelector('.pl-subtitles-space');
  const targetElement = document.querySelector('.base-tour.tour-container .inner');
  return ReactDOM.createPortal(blockToInsert, pathExisting ?? targetElement);
};

export default AudioSubtitleBlock;
